import React, { ChangeEvent } from "react";
import Input from "../Inputs";
import Modal from "../Modal";
import { CONSTANTS } from "../../constants/Constants";
import Select from "../Select";
import moment from "moment";
import logoPlaceHolder from "../../assets/images/logo_placeholder.png"

interface ExpAndEduProps {
  payload: any;
  country?: string;
  city?: string;
  countryOptions: {}[];
  cityOptions: {}[];
  changeLocationHandler: (
    e: ChangeEvent<HTMLSelectElement>,
    state?: "experience"
  ) => void;
  expChangeHandler: (e: ChangeEvent, journey: string) => void;
  saveExpHandler: () => void;
  setIsModalOpen: any;
  cityError: string;
}

const ExperienceModal: React.FC<ExpAndEduProps> = ({
  payload,
  countryOptions,
  cityOptions,
  changeLocationHandler,
  expChangeHandler,
  saveExpHandler,
  setIsModalOpen,
  cityError,
}) => {
  
  return (
    <Modal
      modal_handler={setIsModalOpen}
      save_handler={saveExpHandler}
      other_classes="w-5/12"
      modal_title={CONSTANTS.MODIFY_EXPERIENCE_TXT}
    >
      <div>
        <div className="m-auto flex justify-evenly space-x-5">
          <div className="columns-1 mb-4">
            <label
              htmlFor="update_profile_image"
              className="cursor-pointer text-center flex flex-col items-center justify-center text-sm"
            >
              <img
                src={
                  payload[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_URL
                  ] || logoPlaceHolder
                }
                alt="Company Logo"
                className="object-contain w-24 h-24 rounded-full border border-gray-300"
              />
              {CONSTANTS.LOGO_TXT}
            </label>
            <input
              onChange={(e: ChangeEvent)=>expChangeHandler(e, CONSTANTS.EXPERIENCE_HEADING_TXT)}
              name={
                CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.IMAGE_FILE
              }
              id="update_profile_image"
              className="hidden"
              type="file"
            />
          </div>
          <div className="w-96 space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.COMPANY_TXT}
                <span className="text-error mr-1">*</span>
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                    .ORGANIZATION_NAME
                }
                value={
                  payload[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .ORGANIZATION_NAME || ""
                  ]
                }
                change_handler={(e: ChangeEvent)=>expChangeHandler(e, CONSTANTS.EXPERIENCE_HEADING_TXT)}
                placeholder="Your Company"
                other_classes="text-xs h-[30px]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.TITLE_TXT}
                <span className="text-error mr-1">*</span>
              </label>
              <Input
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.TITLE
                }
                value={
                  payload[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.TITLE
                  ]
                }
                change_handler={(e: ChangeEvent)=>expChangeHandler(e, CONSTANTS.EXPERIENCE_HEADING_TXT)}
                placeholder="Your Title"
                other_classes="text-xs h-[30px]"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.STARTED_ON_TXT}
              </label>
              <Input
                type="month"
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STARTED_ON
                }
                value={
                  payload[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .STARTED_ON
                  ]
                    ? moment(
                        payload[
                          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                            .STARTED_ON
                        ]
                      ).format("YYYY-MM")
                    : ""
                }
                change_handler={(e: ChangeEvent)=>expChangeHandler(e, CONSTANTS.EXPERIENCE_HEADING_TXT)}
                other_classes="text-xs h-[30px]"
                max={moment().format("YYYY-MM")}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.ENDED_ON_TXT}
              </label>
              <Input
                type="month"
                input_name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ENDED_ON
                }
                value={
                  payload[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.ENDED_ON
                  ]
                    ? moment(
                        payload[
                          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                            .ENDED_ON
                        ]
                      ).format("YYYY-MM")
                    : ""
                }
                change_handler={(e: ChangeEvent)=>expChangeHandler(e, CONSTANTS.EXPERIENCE_HEADING_TXT)}
                other_classes="text-xs h-[30px]"
                min={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                      .STARTED_ON
                  ]
                    ? moment(
                        payload?.[
                          CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS
                            .STARTED_ON
                        ]
                      ).format("YYYY-MM")
                    : moment().format("YYYY-MM")
                }
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.COUNTRY_TXT}
              </label>
              <Select
                value={payload?.countryId}
                options={countryOptions}
                handle_change={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  changeLocationHandler(e, "experience")
                }
                name={CONSTANTS.COUNTRY_TXT}
                other_classes="text-xs h-[30px] rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.CITY_TXT}
              </label>
              <Select
                value={payload?.cityId}
                options={cityOptions}
                handle_change={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  changeLocationHandler(e, "experience")
                }
                name={
                  CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.LOCATION_ID
                }
                other_classes="text-xs h-[30px] rounded-md"
              />
              <small className="text-error">{cityError}</small>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                {CONSTANTS.SHOW_ON_PROFILE_TXT}
              </label>
              <Select
                name={CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS}
                value={
                  payload?.[
                    CONSTANTS.PAYLOAD_KEYS.CREATE_UPDATE_RESOURCE_KEYS.STATUS
                  ]
                }
                handle_change={(e: ChangeEvent)=>expChangeHandler(e, CONSTANTS.EXPERIENCE_HEADING_TXT)}
                options={[
                  {
                    id: CONSTANTS.ENABLED_TXT.toLocaleUpperCase(),
                    name: CONSTANTS.YES_TXT,
                  },
                  {
                    id: CONSTANTS.DISABLED_TXT.toLocaleUpperCase(),
                    name: CONSTANTS.NO_TXT,
                  },
                ]}
                other_classes="text-xs h-[30px] rounded-md"
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ExperienceModal;
